module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title has-text-centered is-size-1 has-text-weight-light"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('index.administrating_reception')) + "\n\n    "), _c('span', {
    staticClass: "has-text-info icon is-large",
    class: {
      'fa-spin': _vm.isloading
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  })])]), _vm._v(" "), (_vm.initResponse.objects) ? [_c('div', {
    class: ['wrap', _vm.popupIsShowing ? 'collapseback' : '']
  }, _vm._l((_vm.initResponse.objects), function(object, index) {
    return _c('div', {
      key: index,
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-12"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('p', {
      staticClass: "title has-text-weight-light is-pulled-right"
    }, [_vm._v("\n              " + _vm._s(object.name) + " [" + _vm._s(_vm.$t('index.devices_count')) + " " + _vm._s(object.licenseInfo.panels == 'unlim' ? _vm.$t('index.unlim') : object.licenseInfo.panels) + "]\n            ")]), _vm._v(" "), (object.licenseInfo.expired && object.licenseInfo.expired < Date.now()) ? _c('span', {
      staticClass: "tag is-danger has-text-weight-light is-pulled-right",
      staticStyle: {
        "margin-right": "10px",
        "margin-top": "8px"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.trial_expired')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('a', {
      staticClass: "button is-outlined is-info is-medium",
      on: {
        "click": function($event) {
          _vm.showAddNewKey(index, object)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('index.register_client_' + object.licenseInfo.byod_type)))])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('a', {
      staticClass: "button is-outlined is-info is-medium",
      on: {
        "click": function($event) {
          _vm.showAddNewKey(index, object, 'mauth')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('index.register_client_' + object.licenseInfo.byod_type)))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-tabs', {
      staticClass: "block",
      attrs: {
        "size": "is-medium"
      }
    }, [_c('b-tab-item', {
      attrs: {
        "label": _vm.$t('index.clients_' + object.licenseInfo.byod_type),
        "icon": "user-circle"
      }
    }, [(_vm.activeTokens(object.tokens)) ? [_c('div', {
      staticClass: "wrap_table"
    }, [_c('table', {
      staticClass: "table is-striped is-fullwidth"
    }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('index.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.tag')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.registered_devices')))]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.phone')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.comment')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.check_frequency')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.access_by_email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.custom_session_time')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.custom_panels_limit')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.actions')))])]), _vm._v(" "), _vm._l((object.tokens), function(tokenPropVal, tokenPropKey) {
      return (tokenPropVal.active) ? _c('tr', {
        key: tokenPropKey
      }, [_c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.tag))]), _vm._v(" "), _c('td', [(tokenPropVal.devices) ? _c('a', {
        staticClass: "button is-outlined is-primary is-small",
        on: {
          "click": function($event) {
            _vm.showDevicesDialog(index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(tokenPropVal.devices.length) + "  \n                            "), _c('i', {
        staticClass: "fas fa-mobile-alt"
      })]) : _vm._e()]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.email))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', [_vm._v(_vm._s(_vm._f("facade")(tokenPropVal.phone, '+# (###) ### - ## - ##')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', {
        staticStyle: {
          "white-space": "pre-wrap"
        },
        attrs: {
          "width": "20%"
        }
      }, [_c('div', [_vm._v(_vm._s(tokenPropVal.comment))])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.limitType == 2 ? tokenPropVal.frequencyCheckPeriod : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.bxRightId ? _vm.$t('index.yes') : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1 && tokenPropVal.sessionTime) ? _c('span', [_vm._v(" " + _vm._s(tokenPropVal.sessionTime) + " " + _vm._s(_vm.$t('index.minutes')) + " ")]) : _c('span', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.activationsCount) ? _c('span', [_vm._v("\n                            " + _vm._s(tokenPropVal.activationsCount) + "\n                          ")]) : _c('span', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), _c('td', [(object.licenseInfo.byod_type != 'mauth') ? _c('a', {
        staticClass: "button table-btn is-primary is-small",
        on: {
          "click": function($event) {
            _vm.showEditKey(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-edit"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.edit')))])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('a', {
        staticClass: "button table-btn is-primary is-small",
        on: {
          "click": function($event) {
            _vm.showEditKey(index, tokenPropKey, tokenPropVal, 'mauth')
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-edit"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.edit')))])]) : _vm._e(), _vm._v(" "), _c('a', {
        staticClass: "button table-btn is-info is-small",
        on: {
          "click": function($event) {
            _vm.showPushDialog(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-comment"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.send_message')))])]), _vm._v(" "), _c('a', {
        staticClass: "button table-btn is-link is-small",
        on: {
          "click": function($event) {
            _vm.showQR(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-qrcode"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.qr_code')))])])]), _vm._v(" "), _c('div', {
        class: ['modal customStyleModal', tokenPropVal.deleteKey ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.deleteKey = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.deactivate_confirm')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "notification"
      }, [_c('ul', [_c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.object')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(object.name))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.configuration')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(tokenPropVal.Configuration.name))])]), _vm._v(" "), _c('li', [_c('br'), _vm._v(_vm._s('index.arrival_datetime_' + object.licenseInfo.byod_type) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      })], 1), _vm._v(" "), _c('li', [_c('br'), _vm._v(_vm._s('index.departure_datetime_' + object.licenseInfo.byod_type) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.deleteKey = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.cancel')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-danger",
        on: {
          "click": function($event) {
            _vm.deleteKey(index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.yes')))])])])]), _vm._v(" "), (tokenPropVal.sendingKeyValues) ? _c('div', {
        class: ['modal customStyleModal', tokenPropVal.messageKeyShow ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.messageKeyShow = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('b-tabs', [_c('b-tab-item', {
        attrs: {
          "label": _vm.$t('index.send_push_message'),
          "icon": "comment-alt"
        }
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.push_message_for_connected_devices')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "field"
      }, [_c('b-field', [_c('b-input', {
        attrs: {
          "type": "textarea",
          "placeholder": _vm.$t('index.push_message')
        },
        model: {
          value: (tokenPropVal.sendingKeyValues.title),
          callback: function($$v) {
            _vm.$set(tokenPropVal.sendingKeyValues, "title", $$v)
          },
          expression: "tokenPropVal.sendingKeyValues.title"
        }
      })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.messageKeyShow = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.close')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !tokenPropVal.sendingKeyValues.title
        },
        on: {
          "click": function($event) {
            _vm.send('push', index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.$t('index.send')) + "\n                                  ")])]), _vm._v(" "), (tokenPropVal.email) ? _c('b-tab-item', {
        attrs: {
          "label": _vm.$t('index.send_email'),
          "icon": "envelope"
        }
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.email_for', {
        email: tokenPropVal.email
      })))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "field"
      }, [_c('b-field', [_c('b-input', {
        attrs: {
          "type": "textarea",
          "placeholder": _vm.$t('index.email_message')
        },
        model: {
          value: (tokenPropVal.sendingKeyValues.title),
          callback: function($$v) {
            _vm.$set(tokenPropVal.sendingKeyValues, "title", $$v)
          },
          expression: "tokenPropVal.sendingKeyValues.title"
        }
      })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.messageKeyShow = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.close')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-info",
        attrs: {
          "disabled": !tokenPropVal.sendingKeyValues.title
        },
        on: {
          "click": function($event) {
            _vm.send('email', index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.$t('index.send')) + "\n                                  ")])]) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (tokenPropVal.showQRPopup) ? _c('div', {
        class: ['modal customStyleModal', tokenPropVal.showQRPopup ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.showQRPopup = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.scan_it_for_start')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "columns is-mobile is-centered"
      }, [_c('div', {
        staticClass: "column is-half"
      }, [_c('qr-code', {
        attrs: {
          "size": 300,
          "text": _vm.generateQR(tokenPropVal.key, tokenPropVal)
        }
      })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "columns"
      }, [_c('div', {
        staticClass: "column"
      }, [
        [_c('b-field', {
          attrs: {
            "label": _vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)
          }
        }, [_c('FDateTime', {
          attrs: {
            "value": tokenPropVal.dateLifeFrom
          }
        })], 1)]
      ], 2), _vm._v(" "), (tokenPropVal.dateLifeTo) ? _c('div', {
        staticClass: "column"
      }, [
        [_c('b-field', {
          attrs: {
            "label": _vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)
          }
        }, [_c('FDateTime', {
          attrs: {
            "value": tokenPropVal.dateLifeTo
          }
        })], 1)]
      ], 2) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
        staticClass: "button is-info",
        attrs: {
          "href": "javascript:window.print()"
        }
      }, [_vm._v(_vm._s(_vm.$t('index.print')))]), _vm._v(" "), (tokenPropVal.email) ? _c('button', {
        staticClass: "button is-primary",
        on: {
          "click": function($event) {
            _vm.send('emailqr', index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.send_to_email')))]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "button is-default",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.showQRPopup = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.done')))])])])]) : _vm._e(), _vm._v(" "), (tokenPropVal.devicesKeyShow) ? _c('div', {
        class: ['modal customStyleModal', tokenPropVal.devicesKeyShow ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.devicesKeyShow = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.connected_devices')))]), _vm._v(" "), _c('br'), _vm._v(" "), (tokenPropVal.devices) ? _c('table', {
        staticClass: "table is-striped is-fullwidth",
        staticStyle: {
          "min-width": "100px"
        }
      }, [_c('th', [_vm._v(_vm._s(_vm.$t('index.model')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.last_connect_datetime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.push_sent')))]), _vm._v(" "), _vm._l((tokenPropVal.devices), function(device, dindx) {
        return _c('tr', {
          key: dindx
        }, [_c('td', [_vm._v(_vm._s(device.model))]), _vm._v(" "), _c('td', [_c('FDateTime', {
          attrs: {
            "value": device.lastConnect
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(device.pushCount) + "\n                                  ")])])
      })], 2) : _c('i', [_vm._v(_vm._s(_vm.$t('index.connected_devices_not_found')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.devicesKeyShow = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.close')))])])])]) : _vm._e()]) : _vm._e()
    })], 2)])] : [_c('i', [_vm._v(_vm._s(_vm.$t('index.no_clients_found_' + object.licenseInfo.byod_type)))])]], 2), _vm._v(" "), _c('b-tab-item', {
      attrs: {
        "label": _vm.$t('index.history'),
        "icon": "history"
      }
    }, [(_vm.inactiveTokens(object.tokens)) ? [_c('div', {
      staticClass: "wrap_table"
    }, [_c('table', {
      staticClass: "table is-striped is-fullwidth"
    }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('index.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.tag')))]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.phone')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.comment')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.check_frequency')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.access_by_email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.custom_panels_limit')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.actions')))])]), _vm._v(" "), _vm._l((object.tokens), function(tokenPropVal, tokenPropKey) {
      return (!tokenPropVal.active) ? _c('tr', {
        key: tokenPropKey
      }, [_c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.tag))]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.email))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', [_vm._v(_vm._s(_vm._f("facade")(tokenPropVal.phone, '+# (###) ### - ## - ##')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', {
        staticStyle: {
          "white-space": "pre-wrap"
        },
        attrs: {
          "width": "15%"
        }
      }, [_vm._v(_vm._s(tokenPropVal.comment))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.limitType == 2 ? tokenPropVal.frequencyCheckPeriod : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.bxRightId ? _vm.$t('index.yes') : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.activationsCount) ? _c('span', [_vm._v("\n                            " + _vm._s(tokenPropVal.activationsCount) + "\n                          ")]) : _c('span', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "button is-outlined is-small",
        on: {
          "click": function($event) {
            _vm.showDeleteKey(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-times"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.delete')))])])]), _vm._v(" "), _c('div', {
        class: ['modal customStyleModal', tokenPropVal.deleteKey ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background"
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.delete_history_key_confirm')))]), _vm._v(" "), _c('span', {
        staticClass: "tag is-danger"
      }, [_vm._v(_vm._s(_vm.$t('index.delete_history_key_warning')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "notification"
      }, [_c('ul', [_c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.object')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(object.name))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.configuration')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(tokenPropVal.Configuration.name))])]), _vm._v(" "), _c('li', [_c('br'), _vm._v(_vm._s(_vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      })], 1), _vm._v(" "), (tokenPropVal.dateLifeTo) ? _c('li', [_c('br'), _vm._v(_vm._s(_vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      })], 1) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.deleteKey = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.cancel')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-danger",
        on: {
          "click": function($event) {
            _vm.deleteKey(index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.yes')))])])])])]) : _vm._e()
    })], 2)])] : [_c('i', [_vm._v(_vm._s(_vm.$t('index.no_history_records_found')))])]], 2)], 1)], 1)])])
  })), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.addKeyShowModal,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.addKeyShowModal = $event
      }
    }
  }, [_c('registertoken', _vm._b({
    on: {
      "init_response_push": _vm.emitInitResponsePush,
      "init_load_data": _vm.emitLoadData,
      "show_qr": _vm.emitShowQR
    }
  }, 'registertoken', _vm.addNewKeyData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.editKeyShowModal,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.editKeyShowModal = $event
      }
    }
  }, [_c('updatetoken', _vm._b({
    on: {
      "init_response_update": _vm.emitInitResponseUpdate
    }
  }, 'updatetoken', _vm.editKeyData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.addKeyShowModalMauth,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.addKeyShowModalMauth = $event
      }
    }
  }, [_c('registermauth', _vm._b({
    on: {
      "init_response_push": _vm.emitInitResponsePush,
      "init_load_data": _vm.emitLoadData,
      "show_qr": _vm.emitShowQR
    }
  }, 'registermauth', _vm.addNewKeyData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.editKeyShowModalMauth,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.editKeyShowModalMauth = $event
      }
    }
  }, [_c('updatemauth', _vm._b({
    on: {
      "init_response_update": _vm.emitInitResponseUpdate
    }
  }, 'updatemauth', _vm.editKeyData, false))], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fdc7a32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/reseption_manager/index.vue
// module id = 302
// module chunks = 2